export default "__VITE_ASSET__CFJ0AdG2__"